import { useEffect, useState } from 'react'
import './list-header.css'
import { Link, Route } from 'react-router-dom'

const ListHeader = ( { detail = true , state, type}) => {

    const [member, setMember] = useState(false)
    
    
    const changeState = (value) => {
        console.log(value)
        setMember(value)
        if(value === true){

            <Route path='/profile'/>
        }
    }


    useEffect( () => {
        if(!detail){
            setMember(true)
        }
    }, detail)

    return(
        <>
            {/* {
                type === 'edit' &&
                <div className="office-edit-btn">
                    <button className="delete">Delete Office</button>
                    <button className="save">Save changes</button>
                </div>
            } */}
            {
                type == 'detail' &&
                <div className="header">
                    <Link to={"/agent/offices/detail"} state={state} className={!member ? "detail-sheet" : "detail"} onClick={() => changeState(false)}>Detail</Link>
                    {/* <Link to={"/agent/offices/detail/members"} state={state} className={member ? "member-sheet" : "member"} onClick={() => changeState(true)}>Members</Link> */}
                </div>
            }
            
        </>
    )
}

export default ListHeader